module.exports = "/_next/static/images/trezor_logo-d97d09e3ebfa63911ca6a3898df94922.svg";